import { AngularFireFunctions } from '@angular/fire/functions';
import { Component, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PrintService } from '../print.service';
import { HttpClient } from '@angular/common/http';

import * as firebase from 'firebase';
import { AngularFireStorage } from '@angular/fire/storage';
import { QuoteService } from '../test/quote.service';
import { async } from 'rxjs/internal/scheduler/async';

@Component({
  selector: 'lsu-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InvoiceComponent implements OnInit, AfterViewInit {

  customerId: any;
  customerDetail: any;
  quoteId: any;
  downloadQuoteId: string;
  quoteDetail: any = [];
  transactions: any = [];
  hasQuote: any = true;
  src: string;
  purchaseCondition = `All quotes are final once purchase is made and delivery scheduled. Once delivery is scheduled and truck has
  started
  loading no refunds will be issued and any purchased rock will be delivered. This pdf represents the promised
  quotes
  and will be used as the official record of the order that was placed.`;

  displayedColumns: string[] = ['name', 'image', 'price', 'qty', 'hours', 'shipping', 'avgCostPerTon', 'subtotal'];
  isPrintable = false;
  isDownload = false;
  constructor(route: ActivatedRoute, private quoteService: QuoteService, private storage: AngularFireStorage,
    private printService: PrintService, private fun: AngularFireFunctions, private http: HttpClient) {

    if (route.snapshot.children) {
      this.customerId = route.snapshot.children[0].params['customerId'];
      this.quoteId = route.snapshot.children[0].params['quoteId'];
      let downloadQuote = route.snapshot.children[0].queryParams.quoteId;
      if (downloadQuote) {
        this.customerId = route.snapshot.children[0].queryParams.customerId
        this.downloadQuoteId = downloadQuote;
        this.quoteId = downloadQuote
      }
      // http://localhost:4200/invoice/downloadquote?customerId=yY0qy318iOL4KUas1kE8&quoteId=yY0qy318iOL4KUas1kE8
    }
  }

  async ngOnInit() {
    try {
      [this.quoteDetail, this.customerDetail] = await Promise.all([
        this.quoteService.getCustomerQuoteById(this.customerId, this.quoteId),
        this.quoteService.getCustomerById(this.customerId),
      ])
      this.transactions = this.quoteDetail.products
      this.hasQuote = true;
    }
    catch (err) {
      console.log(err)
      this.hasQuote = false;
    }
  }

  async ngAfterViewInit() {
    //either viewing or (Add/Edit)
    if (this.downloadQuoteId) {
      await this.downloadFile().then(url => {
      })
      this.quoteId = this.downloadQuoteId
    }

  }

  public printPDF() {
    this.isPrintable = true;
    this.printService.onDataReady();
    this.isPrintable = false;
  }

  async downloadFile() {
    const ref = this.storage.ref(`quoteDocuments/${this.downloadQuoteId}.pdf`);
    this.src = await ref.getDownloadURL().toPromise()
    if (!this.src) {
      setTimeout(async () => {
        this.src = await ref.getDownloadURL().toPromise()
      }, 1000)
    }
    this.http.get(`${this.src}`, {
      responseType: 'arraybuffer'
    }
    ).subscribe(response => this.downLoadFileFromHttp(response, "application/pdf"));
  }

  /**
  * Method is use to download file.
  * @param data - Array Buffer data
  * @param type - type of the document.
  */
  downLoadFileFromHttp(data: any, type: string) {
    let blob = new Blob([data], { type: type });
    let url = window.URL.createObjectURL(blob);
    console.log(`URL using http client ${url}`)
    let pwa = window.open(url, null, null, true);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }
}